import type { Session } from "@supabase/supabase-js";

export const getUsableSessionAccessToken = (
  session: Session | null,
  nowMilliseconds = Date.now()
): string | null => {
  const accessToken = session?.access_token;
  if (typeof accessToken !== "string" || accessToken.trim() === "") {
    return null;
  }

  const expiresAt = session?.expires_at;
  if (
    typeof expiresAt === "number" &&
    Number.isFinite(expiresAt) &&
    expiresAt * 1000 <= nowMilliseconds
  ) {
    return null;
  }

  return accessToken;
};
